import componentFactory from '../shared/componentFactory';
import { Header } from '@spotify-internal/masthead';

import '@spotify-internal/masthead/index.css';

export default componentFactory(Header, 'Header');
